<template>
	<div class="details">
		<div class="container">
			<div class="row">
				<div class="col-md-9 mx-auto">
					<div class="form-box review-box completed-form-box">
						<img src="./../../assets/icons/check.png" alt="Check" class="envelope-icon">
						<h1><strong>{{ firstName }}</strong>, you've already finished the on-boarding process!</h1>
						<p>You can proceed to your Investment Portal by clicking on the button below.</p>
						<a :href="investmentPortalEndPoint" class="btn btn-primary mt-5">Proceed to Investment Portal</a>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import {PORTAL_URL} from "@/main";

export default {
    name: "AlreadyCompletedForm",
    beforeMount() {
        // Verify the previous step is completed
        if(!this.$store.getters.review.finished) {
            this.$router.replace("/review");
        }
    },
    data() {
        return {
            firstName: this.$store.getters.personal.firstName,
		}
	},
	computed: {
        token() {
            return this.$store.getters.token;
		},
        investmentPortalEndPoint() {
            return PORTAL_URL + "/auth?t=" + this.token;
		},
	},
}
</script>